export const getMyFx = {
    computed: {
        myFx: {
            get() { return this.$store.getters.getMyFx ? this.$store.getters.getMyFx : false },
            set(value) { this.$store.commit('setMyFx', value)}
        }
    }
}